import init from '../../../js/init';

const name = 'tabs';
const selector = '.tabs';
const tabItemSelector = `${selector}__item`;
const tabSelector = '.tab';
const buttonSelector = '.button';
const buttonPrimaryClass = 'button--primary';
const buttonSecondaryClass = 'button--secondary';
const activeTabClass = 'tab--active';
const contentSelector = `${selector}__content`;
const activeContentClass = `${contentSelector}--active`.substring(1);

init(Drupal, name, selector, root => {
  const variant = root.getAttribute('data-variant');
  const dontUseAnchors = root.getAttribute('data-ignore-anchors') === 'true';
  const tabItems = root.querySelectorAll(tabItemSelector);
  const tabContents = root.querySelectorAll(contentSelector);

  tabItems.forEach((tabItem, idx) => {
    tabItem.onclick = () => {
      if (variant === 'vertical') {
        tabItems.forEach((item, buttonIdx) => {
          const button = item.querySelector(buttonSelector);
          button.classList.remove(buttonPrimaryClass);
          button.classList.remove(buttonSecondaryClass);
          button.classList.add(idx === buttonIdx ? buttonPrimaryClass : buttonSecondaryClass);
        });
      } else {
        tabItems.forEach(item => item.querySelector(tabSelector).classList.remove(activeTabClass));
        const tabElem = tabItems[idx].querySelector(tabSelector);
        tabElem.classList.add(activeTabClass);
        const tabHash = tabElem.getAttribute('data-active-hash');
        if (tabHash && !dontUseAnchors) window.location.hash = tabHash;
      }

      tabContents.forEach(content => content.classList.remove(activeContentClass));
      tabContents[idx].classList.add(activeContentClass);
      window.dispatchEvent(new Event('resize'));
    };
  });

  function activateTabByHash(hash) {
    tabItems.forEach(tabItem => {
      const tabElem = tabItem.querySelector(tabSelector);
      const tabHash = tabElem.getAttribute('data-active-hash');
      if (hash === tabHash && !dontUseAnchors) tabItem.click();
    });
  }

  function listenToHashChange() {
    window.addEventListener('hashchange', () => {
      const hash = window.location.hash.substring(1);
      if (hash && !dontUseAnchors) activateTabByHash(hash);
    }, false);
  }

  const hash = window.location.hash.substring(1);
  if (hash && !dontUseAnchors) activateTabByHash(hash);
  else tabItems[0].click();

  listenToHashChange();
});
